import useSWR from "swr";

import { CURRENT_ORGANIZATION_KEY, getCurrentOrganization } from "@/features/organization/api/organizationApi";
import { toErrorMessage } from "@/lib/swr";

export function useCurrentOrganization() {
  const { data, error, isLoading } = useSWR(CURRENT_ORGANIZATION_KEY, getCurrentOrganization);

  return { organization: data, isLoading, error: toErrorMessage(error) };
}
